import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import { Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import ToolkitProvider, { CSVExport, Search, } from "react-bootstrap-table2-toolkit";
import { faPlus, faSearch, faDownload } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { getServiceEngDDFWorkOrderR, getServiceEngWiseInstallationReport } from "../../Service/AllReportAPI";

import Axios from "../../utils/axiosInstance";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Select from "react-select";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import fileSaver from "file-saver";
import { getServiceEngineerList, } from "../master/AllUserDropDown";
import { getWorkOrderInstallationList, } from "../../Service/AllWorkOrderInstallationAPI";
import moment from "moment";
import swal from "sweetalert";

//import * as Yup from "yup";

export default () => {
  const { SearchBar } = Search;
  const [entries, setEntries] = useState([]);
  const { ExportCSVButton } = CSVExport;
  const selectRow = {
    mode: "checkbox",
  };
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [selectedServiceEngineer, setSelectedServiceEngineer] = useState("");
  const [isLoaded, setisLoaded] = useState(false);
  // --- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    // Function call to get Dispatch list
    getInstallation();
    // getServiceEngList();
    getServiceEngDDFWorkOrderRList();
    // eslint-disable-next-line
  }, []);

  // Function declaration of get customers list
  // const  getServiceEngList = async () => {
  //   await getServiceEngineerList().then((result) => {
  //       setServiceEngineerName(result);
  //   });
  // };

  const getServiceEngDDFWorkOrderRList = async () => {
    let token = sessionStorage.getItem("token");
    let headers = {Authorization: `Bearer ${token}`}
    let jobType = ["installation"];
    await getServiceEngDDFWorkOrderR(headers, jobType)
    .then((result) => {
      console.log("getServiceEngDDFWorkOrderRList Installation result :-", result);
      let serviceEngDD = [];
      let tempserviceEngDDArray = result.data.map((obj) => {
        let serviceEng = obj.split(",");
        return {
          id: `${serviceEng[0]}`,
          value: `${serviceEng[1]}`,
          label: `${serviceEng[1]}`,
        };
      });
      serviceEngDD = tempserviceEngDDArray;
      setServiceEngineerName(serviceEngDD);
      console.log("getServiceEngDDFDEalerList Installation serviceEngDD", serviceEngDD);
    })
    .catch((error) => {
      console.log("getServiceEngDDFWorkOrderRList Installation error :-", error);
    })
  };

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (selectedServiceEngineer === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      await getWorkOrderInstallationList( selectedPage, "installation", fkUserId, role, headers )
      .then((result) => {
        console.log("Get Pagination installation Result", result);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          console.log("data", data);
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotaloffset(totalSize);
          entries.map((item, index) => (item.id = totalSize + index + 1));
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    } else if (selectedServiceEngineer !== "") {
      await getServiceEngWiseInstallationReport( selectedPage, selectedServiceEngineer,"installation" )
      .then((result) => {
        console.log( "Get Pagination Service Engineers wise installation Result", result );
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);
        } else {
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => {
        console.log("Get Field Issue Error", error);
      });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

 // Function declaration of get installation list
 const getInstallation = async () => {
    try {
      const role = sessionStorage.getItem('role');
      const fkUserId = sessionStorage.getItem('pkUserId');
      const token = sessionStorage.getItem("token");
      const headers= {"Authorization" : `Bearer ${token}`};
      await getWorkOrderInstallationList(currentPage, "installation", fkUserId, role, headers)
      .then((result) => {
        console.log("Work Order Service Engineer Installation Result List", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);
        }  else {
          setEntries([]);
          setPageCount();
          setTotalCount();
        }
      })
      .catch((error) => {
        console.log("Work Order Service Engineer Installation Error", error);
      });
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getServiceEngWisePdfDownload = async () => {
    try {
      if (selectedServiceEngineer !== "") {
        setisLoaded(true);
        let role = sessionStorage.getItem('role');
        let fkUserId = sessionStorage.getItem('pkUserId');
        let token = sessionStorage.getItem("token");
        let jobType = ["installation"];
        let fileType = ["Pdf"];
        return await Axios.get(`serviceEngineerWiseWorkOrderReportPdf?role=${role}&fkUserId=${fkUserId}&fileType=${fileType}&jobType=${jobType}&serviceEngineerName=${selectedServiceEngineer}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          var blob = new Blob([response.data], { type: "application/pdf" });
          fileSaver.saveAs(blob, `serviceengineerwiseinstallationreport.pdf`);
          setisLoaded(false);
        });
      } else {
        swal("Failed", "Please Select Service Engineer Name", "error");
      }
    } catch (error) {
      setisLoaded(false);
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  const getServiceEngWiseExcelDownload = async (e) => {
    try {
      if (selectedServiceEngineer !== "") {
        let role = sessionStorage.getItem('role');
        let fkUserId = sessionStorage.getItem('pkUserId');
        let token = sessionStorage.getItem("token");
        let jobType = ["installation"];
        let fileType = ["Excel"];
        return await Axios.get(`serviceEngineerWiseWorkOrderReportPdf?role=${role}&fkUserId=${fkUserId}&fileType=${fileType}&jobType=${jobType}&serviceEngineerName=${selectedServiceEngineer}`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          var blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          fileSaver.saveAs(blob, `serviceengineerwiseworkorderinstallation.xlsx`);
        });
      } else {
        swal("Failed", "Please Select Service Engineer Name", "error");
      }
    } catch (error) {
      console.log(error);
      swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));
  // Column heading of installation list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "workOrderSerialNo",
      text: "Work Order No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "installationDate",
      text: "Date",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>
            {moment(cell).format("DD-MMM-YYYY")}
          </>;
      },
    },
    {
      dataField: "installationTime",
      text: "Time",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => {
        return <>
            {moment(cell, 'hh:mm A').format('hh:mm A')}
          </>
      },
    },
    {
      dataField: "customerName",
      text: "Customer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "dealerName",
      text: "Dealer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerName",
      text: "Service Engineer Name",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "serviceEngineerMobNo",
      text: "Service Engineer Mobile No",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "jobPreference",
      text: "Job Reference",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "dispenserType",
      text: "Dispenser Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "siteType",
      text: "Site Type",
      editable: false,
      headerAlign: "left",
    },
    {
      dataField: "installationAddress",
      text: "Site Address",
      editable: false,
      headerAlign: "left",
      formatter: (cell) => (
        <div className="content-cell">
          <span>{cell}</span>
        </div>
      )
    },
  ];

  // custom the pagination total
  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  // callback function when page was changing
  const customSizePerPage = (props) => {
    const { options, currentSizePerPage, onSizePerPageChange } = props;
    const onPageChange = (e) => {
      const page = e.target.value;
      onSizePerPageChange(page);
    };

    return (
      <>
        <Row>
          <Col xs="auto">
            <Form.Select
              value={currentSizePerPage}
              onChange={onPageChange}
              className="pe-5"
            >
              {options.map((o) => (
                <option key={o.page} value={o.page}>
                  {o.text}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs="auto" className="d-flex align-items-center">
            Entries per page
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <Formik
          initialValues={{}}
          onSubmit={async (values) => {
            console.log(JSON.stringify(values, null, 2));
          }}
        >
          {(formik) => {
            return (
              <>
                <Row>
                  <div>
                    <h5 className="headNew mb-4">
                      Service Engineer Name Wise Report
                    </h5>
                  </div>
                  <Col md={6} className="mb-3">
                    <div className="form-group">
                      <label className="Label mb-1">Service Engineer Name</label>
                      <Select
                        name="serviceEngineerName"
                        placeholder="Select Service Engineer Name"
                        title="Select Service Engineer Name"
                        options={serviceEngineerName}
                        onChange={async (e) => {
                          formik.setFieldValue(currentPage,"serviceEngineerName", e.value);
                          setSelectedServiceEngineer(e.value);
                          await getServiceEngWiseInstallationReport(currentPage, e.value,"installation" )
                          .then((result) => {
                            console.log("Service Engineer Details", result.data);
                            if (result?.data?.content?.length !== 0) {
                              const data = result.data.content;
                              setEntries(data);
                              setPageCount(result.data.totalPages);
                              setTotalCount(result.data.totalElements);
                            } else {
                              setEntries([]);
                              setPageCount();
                              setTotalCount();
                              swal("Sorry", "Data is not present", "warning");
                            }
                          })
                          .catch((error) => {
                            console.log("Service Engineer Error", error);
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
{/* --- When you use any toolkit functionalities, you are supposed to render toolkit component and
  BootstrapTable as the children of ToolkitProvider --- */}
                <ToolkitProvider
                  keyField="id"
                  search={true}
                  columns={columns}
                  data={entries}
                  exportCSV={{ onlyExportFiltered: true, exportAll: false }}
                >
                  {({ baseProps, searchProps, csvProps }) => (
                    //render the Pagination component as a list with left and right arrows
                    <Paginator.PaginationProvider
                      pagination={Pagination({
                        custom: true,
                        disablePageTitle: true,
                        alwaysShowAllBtns: true,
                        totalSize: totalCount,
                        paginationTotalRenderer: customTotal,
                        onPageChange: handlePageChange,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <Card>
                          <div className="table-responsive py-2">
                            <Card.Header>
                              <Row>
                                <Col xs={12} md={6} className="py-1">
                                  {/* <Paginator.SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end py-1"
                                >
                                  {/* props for search component */}
                                  {/* <Search.SearchBar {...searchProps} />{" "} */}
                                  {/* props for csv component */}
                                  {/* <ExportCSVButton
                                    {...csvProps}
                                    className="btn btn-secondary mx-2"
                                  >
                                    <span>CSV</span>{" "}
                                  </ExportCSVButton> */}
                                  <button
                                    className="btn btn-secondary mx-2"
                                    onClick={getServiceEngWisePdfDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>PDF</span>{" "}
                                  </button>
                                  <button
                                    className="btn btn-secondary"
                                    onClick={getServiceEngWiseExcelDownload}
                                  >
                                    <FontAwesomeIcon icon={faDownload} className="me-2" />
                                    <span>Excel</span>
                                  </button>
                                </Col>
                              </Row>
                            </Card.Header>
                            <Table
                              {...baseProps}
                              {...paginationTableProps}
                              bodyClasses="border-0"
                              rowClasses="border-bottom"
                              classes="table-flush dataTable-table"
                              // selectRow={selectRow}
                              filter={filterFactory()}
                              headerClasses="header-class"
                              hover
                              striped
                              condensed
                              remote= {{pagination:true}}
                              cellEdit={cellEditFactory({
                                mode: "click",
                                blurToSave: true,
                                afterSaveCell: (
                                  oldValue,
                                  newValue,
                                  row,
                                  column
                                ) => {
                                  const changeRowData = {
                                    selectedRow: row,
                                    cellChange: newValue,
                                    columnChange: column,
                                  };
                                  setChangeRowData(changeRowData);
                                },
                              })}
                              wrapperClasses="table-responsive"
                            />
                            <Card.Footer>
                              <Row>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex align-items-center py-1"
                                >
                                    {/* <Paginator.PaginationTotalStandalone
                            {...paginationProps}
                          /> */}
                                </Col>
                                <Col
                                  xs={12}
                                  md={6}
                                  className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                                >
                                  <Paginator.PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </Card.Footer>
                          </div>
                        </Card>
                      )}
                    </Paginator.PaginationProvider>
                  )}
                </ToolkitProvider>
              </>
            );
          }}
        </Formik>
      )}
    </>
  );
};
// }};
